import * as React from 'react';

type NotificationIconProps = {
  status: 'warning' | 'error' | 'info' | 'success' | 'none';
};
const helper = {
  warning: '#f4a234',
  error: '#ed3833',
  info: '#2b90f7',
  success: '#5ecc61',
  none: '#fff',
};

export default ({ status }: NotificationIconProps) => (
  <svg
    data-name="Component 1 \u2013 1"
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={23}
  >
    <circle
      data-name="Ellipse 653"
      cx={11.5}
      cy={11.5}
      r={11.5}
      fill={helper[status]}
    />
    <text
      transform="translate(9.965 16.884)"
      fill="#fff"
      fontSize={14}
      fontFamily="Poppins-Bold, Poppins"
      fontWeight={700}
    >
      <tspan x={0} y={0}>
        i
      </tspan>
    </text>
  </svg>
);
